import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CustomPropTypes from "../utils/customPropTypes";
import GenericBanner from './GenericBanner/GenericBanner';
import style from '../../scss/components/HeroGrid';
export default class HeroGrid extends React.Component {
    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                eyebrow: PropTypes.string,
                title: PropTypes.string,
                description: PropTypes.string,
                image: CustomPropTypes.Image,
                mobileImage: CustomPropTypes.Image,
                button: CustomPropTypes.Link
            })
        )
    };
    render() {
        return (
            <section className="hero-grid-section">
                <div className="container">
                    <ul className="hero-grid-list">
                        {this.props.items.map(function (objItem, index) {
                            return (
                                <li key={index}>
                                    <GenericBanner {...objItem} controlType={GenericBanner.ControlTypes.HeroGridCard}>
                                    </GenericBanner>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </section>
        );
    }
}
